class ValueComparer {
    constructor() {

    }

    /* 
    isDeepEqual 
        compares variables of all types to see if they are equal
        
        intended for arrays and objects which don't always work with "exact equals"
            for example, the prototype properties of those objects can be different, so they will never be equal
        so this self recursively loops through arrays and objects in order to compare check primitive types with "exact equals"

        @param  obj1  (any)
        @param  obj2  (any)

        @return  (boolean)  true when obj1 and obj2 are equal
    */
    isDeepEqual = (obj1, obj2) => {
        // if the objects are the different types
        // then they are not the same 
        if (typeof obj1 !== typeof obj2) {
            return false;
        }

        // handle edge case where both objects are null
        // typeof null is "object", but it doesn't have keys and is not iterable. welcome to javascript
        if (obj1 === null && obj2 === null) {
            return true;
        }

        // if they are primitive types
        // then compare them directly
        if (typeof obj1 !== "object" || obj1 === null) {
            return obj1 === obj2;
        }

        // if they are arrays
        // then compare each element recursively
        if (Array.isArray(obj1)) {
            if (obj1.length !== obj2.length) {
                return false;
            }
            for (let i=0; i<obj1.length; i++) {
                if (this.isDeepEqual(obj1[i], obj2[i]) === false) {
                    return false;
                }
            }
            return true;
        }

        // if they are objects
        // then compare each property recursively
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
            return false;
        }

        for (const key of keys1) {
            if (this.isDeepEqual(obj1[key], obj2[key]) === false) {
                return false;
            }
        }

        return true;
    }
}

export default ValueComparer;